import { baseKeymap, setBlockType, toggleMark, wrapIn } from 'prosemirror-commands';
import { redo, undo } from 'prosemirror-history';
import { keymap } from 'prosemirror-keymap';

import { schema } from '../schema';

export const keymapPlugin = keymap({
  'Mod-z': undo,
  'Mod-y': redo,
  'Mod-Shift-z': redo,
  'Mod-b': toggleMark(schema.marks.bold),
  'Mod-i': toggleMark(schema.marks.italic),
  'Mod-u': toggleMark(schema.marks.underline),
  'Shift-Mod-x': toggleMark(schema.marks.strike),
  'Shift-Mod-1': setBlockType(schema.nodes.heading, { level: 1 }),
  'Shift-Mod-2': setBlockType(schema.nodes.heading, { level: 2 }),
  'Shift-Mod-3': setBlockType(schema.nodes.heading, { level: 3 }),
  'Shift-Mod-0': setBlockType(schema.nodes.paragraph),
  'Shift-Mod->': wrapIn(schema.nodes.blockquote),
});

export const baseKeymapPlugin = keymap(baseKeymap);
